import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';
import { rtkAppRetry } from '#store/apiRetry.ts';

export const TAGS = {
    DOCUMENTS: 'DOCUMENTS',
};
export const customFetchBaseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_ORDERCOM_DOCUMENT_API_PROXY,
    credentials: 'include',
    mode: 'cors',
    prepareHeaders,
});

export const apiRootDocuments = createApi({
    tagTypes: Object.keys(TAGS),
    reducerPath: 'apiDocuments',
    baseQuery: rtkAppRetry(customFetchBaseQuery),
    endpoints: () => ({}),
});
